import React from 'react';
import { Row } from 'components/Containers/Row/Row';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { SUGGESTED_ACTIONS } from 'types/morph.pagePosition.constants';
import { useSeenModulePixel } from 'hook/helper.hook';
import { CREDIT_PROFILE } from 'types/marketplaceTiles.constants';
import GoalCard from 'pages/Goals/components/GoalsView/components/GoalsCard/GoalCard';
import { CardsConfig } from 'goals_card_config/config';
import OfferCarousel from 'components/Fragments/OfferCarousel/OfferCarousel';
import './ActionModuleRedesign.scss';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { NAVIGATION } from 'externals/_tracking/types/clickEventTypes.constants';
import { useHistory } from 'react-router-dom';
import { Button } from 'components/form/Button/Button';
import { Disclaimer } from 'components/AdvertiserToolTip/AdvertiserToolTip';

const SeeAll = props => {
  const { eventHandler } = props;
  const history = useHistory();

  const handleClick = () => {
    eventHandler(CLICK, {
      'Click Type': NAVIGATION,
    });
    history.push('/creditManager/goals');
  };

  return (
    <Button
      mrphType="standardBlue"
      className="Body1"
      rounded="100px"
      onClick={handleClick}
    >
      SEE ALL ACTIONS
    </Button>
  );
};

const OffersView = props => {
  const {
    actions,
    pagePosition,
    modulePosition,
    eventHandler,
    autoRefinanceInfo,
    config,
  } = props;
  if (actions?.length >= 1) {
    return (
      <>
        <FlexContainer className={'flex-column m-hide t-hide'}>
          <Row type="carousel" className={'padLR0'}>
            <OfferCarousel type={'creditCardRedesignCarousel'}>
              {actions?.map((action, index) => (
                <FlexContainer
                  className={'goal-carousel-item padlr6 padB6'}
                  key={`action-card-goal-${action?.name}`}
                >
                  <GoalCard
                    key={`action-card-goal-${action?.name}`}
                    action={action}
                    modulePosition={modulePosition}
                    offerPosition={index + 1}
                    moduleName={pagePosition}
                    eventHandler={eventHandler}
                    autoRefinanceInfo={autoRefinanceInfo}
                    config={config}
                  />
                </FlexContainer>
              ))}
            </OfferCarousel>
          </Row>
        </FlexContainer>
        <FlexContainer className={'d-hide flex-column gap-20'}>
          {actions?.slice(0, 3).map((action, index) => (
            <GoalCard
              key={`action-card-goal-mobile-${action?.name}`}
              action={action}
              modulePosition={modulePosition}
              offerPosition={index + 1}
              moduleName={pagePosition}
              eventHandler={eventHandler}
              autoRefinanceInfo={autoRefinanceInfo}
              config={config}
            />
          ))}
        </FlexContainer>
      </>
    );
  } else {
    <></>;
  }
};

const ActionsModuleRedesignView = props => {
  const {
    actionsByGoals,
    eventHandler,
    modulePosition,
    autoRefinanceInfo,
    config,
  } = props;

  const actions = actionsByGoals?.filter(
    action => CardsConfig[action.name] || false,
  );

  const trackingAtr = getViewModuleTrackingAttributes({
    pagePosition: SUGGESTED_ACTIONS,
    modulePosition: modulePosition,
    vertical: CREDIT_PROFILE,
  });
  const seenModuleTracking = useSeenModulePixel(trackingAtr);

  return (
    <FlexContainer className={'flex-column goal-carousel'}>
      {seenModuleTracking}
      {config?.phxHomepageActions && <Disclaimer className="margB12" />}
      <FlexContainer className={'flex-column gap-14'}>
        {actions?.length >= 1 && (
          <OffersView
            actions={actions}
            modulePosition={modulePosition}
            eventHandler={eventHandler}
            autoRefinanceInfo={autoRefinanceInfo}
            config={config}
          />
        )}
        <SeeAll
          className={
            'd-hide Body2 text-center margt10 padB0 text-12 m-text-12 align-baseline secondary_text_light'
          }
          eventHandler={eventHandler}
        />
      </FlexContainer>
    </FlexContainer>
  );
};

export default ActionsModuleRedesignView;
